var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ordered",
    transform: "translate(-617 -568)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11156",
    "data-name": "Rectangle 11156",
    width: 36,
    height: 36,
    rx: 4,
    transform: "translate(617 568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "attach_file_black_24dp",
    transform: "translate(623 574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47202",
    "data-name": "Path 47202",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47203",
    "data-name": "Path 47203",
    d: "M16.5,6.75V17.33a4.116,4.116,0,0,1-3.61,4.15A3.993,3.993,0,0,1,8.5,17.5V5.14a2.6,2.6,0,0,1,2.24-2.63A2.5,2.5,0,0,1,13.5,5V15.5a1,1,0,0,1-2,0V6.75a.75.75,0,0,0-1.5,0v8.61a2.6,2.6,0,0,0,2.24,2.63A2.5,2.5,0,0,0,15,15.5V5.17a4.116,4.116,0,0,0-3.61-4.15A4,4,0,0,0,7,5V17.27a5.659,5.659,0,0,0,4.96,5.71A5.505,5.505,0,0,0,18,17.5V6.75a.75.75,0,0,0-1.5,0Z",
    fill: "#4b4e6d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.eaff76b74ebccdf44e30c4f7cae0fbdb.svg";
export { ForwardRef as ReactComponent };